import { Type } from "lucide-react";

import type { TextComponent } from "@src/store/slices/experienceBuilder/types";
import { ModificationListItem } from "@src/features/experienceBuilder/modifications/common/ModificationListItem";
import { stripHTML } from "@src/utils/stripHTML";

export const TextComponentListItem = ({ mod }: { mod: TextComponent }) => {
  const subtitle = mod.description || stripHTML(mod.content) || "Empty text";
  return (
    <ModificationListItem
      mod={mod}
      icon={<Type size={16} />}
      title="Text component"
      subtitle={subtitle}
    />
  );
};
